import React from "react"

import FieldRag_OptionPill from "../option-pill"

export default function FieldRag_MultiselectValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className={Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => <FieldRag_OptionPill key={option.value} option={option} onDelete={props.onDelete}/>)}
            </div>
            {props.children}
        </React.Fragment>
    )
}